// 从社区图片详情点过来的自动填充生图参数的弹窗
import React from 'react';
import { modals } from '@mantine/modals';
import { MODEL_SDXL, BASETYPE_NAME_TO_VALUE } from '@shakkerai/pro-models';
import { samplerMethodOptions } from '@shakkerai/pro-constants';
import { notifySuccess } from '@shakkerai/pro-components';
import { getActiveGeneratorNodeId, updateUnitData } from '@starflow/app/helpers/flow';
// import { switchGlobalMode } from '@shakkerai/pro-utils';

const ReferGenerationParamsModal = (props) => {
  const { imageInfo } = props;

  const { width, height, generateInfo: genInfo = {} } = imageInfo;
  const baseModel = imageInfo?.mixModels?.find((item) => item.modelType === 1);
  const loraModels = imageInfo?.mixModels?.filter((item) => item.modelType === 5);

  const handleApplyGenerationInfo = () => {
    // const isSimpleMode = getTempState('globalMode') === 'simple';
    // if (isSimpleMode) {
    //   switchGlobalMode('pro');
    // }
    const genetatorId = getActiveGeneratorNodeId();

    if (!genetatorId) return;

    const { cfgScale, samplingMethod, samplingStep, seed, prompt, negativePrompt } = genInfo;
    const params = { cfgScale, samplingSteps: samplingStep, seed, prompt, negativePrompt, width, height };

    if (samplingMethod) {
      params.samplerMethod = samplerMethodOptions.find((i) => i.label === samplingMethod)?.value;
    }

    if (baseModel) {
      const appliedModel = {
        name: baseModel.modelName + '_' + baseModel.versionName,
        uuid: baseModel.versionUuid,
        versionId: baseModel?.versionId,
        baseType: BASETYPE_NAME_TO_VALUE[baseModel.baseType] || 'SD XL',
        modelType: 'checkpoint',
        imageUrl: baseModel.imageUrl,
        modelId: baseModel.id,
        modelUuid: baseModel.modelUuid,
        modelName: baseModel.modelName,
        vipUsed: baseModel.vipUsed,
      };

      params.mode = 1;
      params.baseType = baseModel.baseType || MODEL_SDXL;
      params.checkpoint = appliedModel;
    } else {
      params.checkpoint = null;
      params.baseType = MODEL_SDXL;
    }

    if (Array.isArray(loraModels)) {
      params.loraModels = loraModels.map((item) => {
        return {
          name: item.modelName + '_' + item.versionName,
          uuid: item.versionUuid,
          versionId: item?.versionId,
          baseType: BASETYPE_NAME_TO_VALUE[item.baseType] || 'SD XL',
          modelType: 'lora',
          imageUrl: item.imageUrl,
          modelId: item.id,
          modelUuid: item.modelUuid,
          modelName: item.modelName,
          weight: 0.7,
          vipUsed: item.vipUsed,
        };
      });
    } else {
      params.loraModels = [];
    }

    Object.keys(params).forEach((key) => {
      if (typeof params[key] === 'undefined') {
        delete params[key];
      }
    });

    try {
      updateUnitData(genetatorId, params);
      notifySuccess('Parameters are all set');
    } catch (error) {
      console.log(error);
    }

    modals.close('communityImageGenerationInfoModal');
  };

  return (
    <div className="flex flex-col items-center w-[820px] tiny-scrollbar h-[645px] p-6 bg-[#000513] border border-white/20 rounded-xl">
      <span className="mt-[22px] text-white text-[26px] font-bold">Send generation info to generator </span>
      <div className="flex self-stretch items-stretch justify-between mt-[43px]">
        <img src={imageInfo.imageUrl} className="w-[320px] h-[497px] object-cover rounded-lg" />
        <div className="flex flex-col w-[434px]">
          <div className="p-3 bg-[#1C1D29] rounded-lg">
            <span className="px-2 text-sm text-white/80 font-semibold">Prompt</span>
            <p className="h-[78px] mt-2 p-3 overflow-auto tiny-scrollbar bg-[#000513] rounded-lg text-white/60 text-sm font-medium">
              {genInfo.prompt || '-'}
            </p>
          </div>
          <div className="mt-3 p-3 bg-[#1C1D29] rounded-lg">
            <span className="px-2 text-sm text-white/80 font-semibold">Negative Prompt</span>
            <p className="h-[78px] mt-2 p-3 overflow-auto tiny-scrollbar bg-[#000513] rounded-lg text-white/60 text-sm font-medium">
              {genInfo.negativePrompt || '-'}
            </p>
          </div>
          <div className=" mt-4 px-3">
            <div className="flex items-center">
              <span className="w-[138px] text-white/80 text-sm font-semibold">CHECKPOINT</span>
              <span className="flex-1 whitespace-nowrap overflow-hidden text-white/60 text-sm font-medium text-ellipsis">
                {genInfo.originalModelName || baseModel?.modelName || '-'}
              </span>
            </div>
            <div className="flex items-center mt-[15px]">
              <span className="w-[138px] text-white/80 text-sm font-semibold">Sampler</span>
              <span className="flex-1 whitespace-nowrap overflow-hidden text-white/60 text-sm font-medium text-ellipsis">
                {genInfo.samplingMethod || '-'}
              </span>
            </div>
            <div className="flex items-center mt-[15px]">
              <span className="w-[138px] text-white/80 text-sm font-semibold">CFG Scale</span>
              <span className="flex-1 whitespace-nowrap overflow-hidden text-white/60 text-sm font-medium text-ellipsis">
                {genInfo.cfgScale}
              </span>
            </div>
            <div className="flex items-center mt-[15px]">
              <span className="w-[138px] text-white/80 text-sm font-semibold">Steps</span>
              <span className="flex-1 whitespace-nowrap overflow-hidden text-white/60 text-sm font-medium text-ellipsis">
                {genInfo.samplingStep}
              </span>
            </div>
          </div>
          <div className="flex-1" />
          <button
            onClick={handleApplyGenerationInfo}
            className="self-stretch h-[60px] bg-primary rounded-lg text-black text-lg font-bold"
          >
            Send to generator
          </button>
        </div>
      </div>
    </div>
  );
};

export const openReferGenerationParamsModal = (imageInfo) => {
  modals.open({
    w: 820,
    size: 820,
    trapFocus: false,
    modalId: 'communityImageGenerationInfoModal',
    centered: true,
    withCloseButton: true,
    closeButtonProps: {
      className: 'bg-black/40 border border-white/20 rounded-full',
    },
    closeOnClickOutside: true,
    closeOnEscape: false,
    classNames: {
      overlay: 'bg-black/80',
      header: 'bg-transparent',
      content: 'p-0 bg-transparent tiny-scrollbar',
      body: 'p-0 bg-transparent',
    },
    children: <ReferGenerationParamsModal imageInfo={imageInfo} />,
  });
};
